import request from '@/assets/js/utils/request'
const baseurl = 'AppClient/Baoxiu/'

//申请故障报修
export function Create(data){
  return request({
    url: baseurl +'Create',
    method: 'post',
    data
  })
}

//故障类型
export function TypeList(data){
  return request({
    url: baseurl +'TypeList',
    method: 'post',
    data
  })
}

//故障地点
export function AddressList(data){
  return request({
    url: baseurl +'AddressList',
    method: 'post',
    data
  })
}

//获取当前用户身份 (0普通用户,1维修人员,2分理人)
export function Identity(data){
  return request({
    url: baseurl +'Identity',
    method: 'post',
    data
  })
}

//当前人发起的历史故障数据
export function MyList(data){
  return request({
    url: baseurl +'MyList',
    method: 'post',
    data
  })
}

//当前人可分理的数据
export function MyManagerList(data){
  return request({
    url: baseurl +'MyManagerList',
    method: 'post',
    data
  })
}

//当前人需要维修的数据表
export function MyWorkerList(data){
  return request({
    url: baseurl +'MyWorkerList',
    method: 'post',
    data
  })
}


//获取故障单数据
export function GetModel(data){
  return request({
    url: baseurl +'GetModel',
    method: 'post',
    data
  })
}

//设置维修人
export function SetWorker(data){
  return request({
    url: baseurl +'SetWorker',
    method: 'post',
    data
  })
}

//完成工单
export function Finish(data){
  return request({
    url: baseurl +'Finish',
    method: 'post',
    data
  })
}

//提交评论
export function Evaluation(data){
  return request({
    url: baseurl +'Evaluation',
    method: 'post',
    data
  })
}

//获取故障单所有评论
export function Comment(data){
  return request({
    url: baseurl +'Comment',
    method: 'post',
    data
  })
}

//当前人可操作的维修人员
export function WorkerList(data){
  return request({
    url: baseurl +'WorkerList',
    method: 'post',
    data
  })
}

//更改故障类型
export function UpdateType(data){
  return request({
    url: baseurl +'UpdateType',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/assets/js/api/baoxiu.js